import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

// Prerendered head tags are for crawlers; React renders its own per page.
document.querySelectorAll("[data-pre]").forEach(e => e.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
